export default "__VITE_ASSET__dc05ee60__"